import React, { useEffect } from "react";
import PaymentMainDashboard from "../../../Components/PaymentLedger/PaymentMainDashboard/PaymentMainDashboard";
import { useDispatch, useSelector } from "react-redux";
import {
  walletAccount,
  walletContract,
  walletTransaction,
} from "../../../Redux/Slices/paymentSlice";

const PaymentLedger = () => {
  const dispatch = useDispatch();
  const role = useSelector(
    (state) => state?.persistedReducer?.user?.activeRole,
  )?.toLowerCase();
  const data = useSelector((state) => state?.persistedReducer?.user);

  useEffect(() => {
    if (!role && !data) return;
    dispatch(
      walletAccount({
        role: role,
        id: data?.activeGeneratorId || data?.activeConsumerId,
      }),
    );
  }, [dispatch, role, data?.activeGeneratorId, data?.activeConsumerId, data]);

  return (
    <div style={{ height: "100%" }}>
      <PaymentMainDashboard />
    </div>
  );
};

export default PaymentLedger;
